import React from 'react'
import SuccessMessageSvg from '../../../svg/SuccessMessage.jsx'
import LoginTransition from '../../LoginPage/components/LoginTransition'

const SuccessForgotPassword = () => {
    return (
        <LoginTransition>
            <div className="w-full h-full flex flex-col items-center justify-center gap-y-6 transition-all">
                <SuccessMessageSvg
                    bg="#42474D"
                    iconColor="#FFC20D"
                    border="#363A3F"
                    hasBorderOpacity={false}
                    className="w-14 h-14 m-0"
                />

                <p className="text-center text-white font-normal text-base">
                    If this email matches an account, you will receive a password reset email shortly.
                    <br />
                    Check your inbox and spam folder.
                </p>
            </div>
        </LoginTransition>
    )
}

export default SuccessForgotPassword
